const LOCALE_IT = 'it';
const LOCALE_FR = 'fr';

export {
  LOCALE_IT,
  LOCALE_FR,
}
